module.exports = __webpack_public_path__ + "static/swizz-4ec9bd730bb34c4eb6db878d439541c8.jpg";